export const CLIENT_META = {
  galleryId: 'client-sunil-thriveni',
  coupleNames: 'Sunil & Thriveni',
  eventType: 'Wedding Gallery',
  date: 'December 24, 2025',
  location: 'Visakhapatnam, India',
  totalPhotos: 850,
  coverImage: '/images/Slide-2.png',
  expiresAt: 'January 24, 2026',
};

export const CLIENT_CATEGORIES = [
  { id: 'all',         label: 'All Photos' },
  { id: 'pre-wedding', label: 'Pre Wedding' },
  { id: 'wedding',     label: 'Wedding' },
  { id: 'reception',   label: 'Reception' },
  { id: 'haldi',       label: 'Haldi' },
  { id: 'mehendi',     label: 'Mehendi' },
  { id: 'family',      label: 'Family' },
  { id: 'candid',      label: 'Candid' },
];

// Replace src / thumb / width / height with real CDN paths.
// thumb: low-res placeholder (~40px wide) for blur-up progressive loading.
const cp = (id, category, w, h) => ({
  id,
  src: `https://picsum.photos/seed/cl${id}/${w}/${h}`,
  thumb: `https://picsum.photos/seed/cl${id}/40/${Math.round((40 * h) / w)}`,
  width: w,
  height: h,
  category,
  alt: `Photo ${id}`,
  filename: `REDANTZ_${String(id).padStart(4, '0')}.jpg`,
});

export const CLIENT_PHOTOS = [
  cp(1,  'wedding',     1200, 1800),
  cp(2,  'pre-wedding', 1200, 820),
  cp(3,  'wedding',     820,  1200),
  cp(4,  'haldi',       1200, 900),
  cp(5,  'wedding',     900,  1300),
  cp(6,  'mehendi',     1000, 1400),
  cp(7,  'reception',   1200, 800),
  cp(8,  'pre-wedding', 820,  1200),
  cp(9,  'candid',      1200, 900),
  cp(10, 'family',      1200, 1100),
  cp(11, 'wedding',     850,  1300),
  cp(12, 'haldi',       1200, 850),
  cp(13, 'reception',   820,  1200),
  cp(14, 'candid',      1200, 820),
  cp(15, 'pre-wedding', 900,  1400),
  cp(16, 'mehendi',     1200, 950),
  cp(17, 'family',      950,  1250),
  cp(18, 'wedding',     1200, 820),
  cp(19, 'reception',   1000, 1400),
  cp(20, 'candid',      1200, 900),
  cp(21, 'wedding',     820,  1200),
  cp(22, 'haldi',       1200, 1800),
  cp(23, 'family',      1200, 820),
  cp(24, 'mehendi',     900,  1250),
  cp(25, 'pre-wedding', 1200, 820),
  cp(26, 'wedding',     820,  1200),
  cp(27, 'reception',   1200, 900),
  cp(28, 'candid',      1100, 1400),
  cp(29, 'family',      1200, 820),
  cp(30, 'wedding',     900,  1300),
  cp(31, 'haldi',       1200, 820),
  cp(32, 'reception',   820,  1200),
  cp(33, 'pre-wedding', 1200, 900),
  cp(34, 'candid',      1000, 1300),
  cp(35, 'mehendi',     1200, 820),
  cp(36, 'wedding',     900,  1200),
  cp(37, 'wedding',     1200, 1600),
  cp(38, 'reception',   1100, 820),
  cp(39, 'candid',      820,  1200),
  cp(40, 'family',      1200, 1000),
  cp(41, 'haldi',       900,  1300),
  cp(42, 'pre-wedding', 1200, 820),
  cp(43, 'wedding',     1200, 900),
  cp(44, 'mehendi',     820,  1200),
  cp(45, 'reception',   1000, 820),
  cp(46, 'family',      1200, 1400),
  cp(47, 'candid',      820,  1200),
  cp(48, 'wedding',     1200, 820),
];

export const PAGE_SIZE = 24;
